import $ from 'jquery';

// Bootstrap 5 tooltips and popovers are opt-in — the data-bs-toggle marker on
// its own does nothing. This module scans the document for tooltip triggers
// and initializes each one exactly once. Runs on DOMContentLoaded and again
// whenever ajax:complete fires so tooltips inside AJAX-injected markup work
// too.
//
// Popovers are NOT globally initialized here on purpose: several call sites
// (notably ai_score_tooltip.js) attach their own popovers with custom content
// and would fight a generic init.
function initTooltips(root) {
  if (!window.bootstrap || !window.bootstrap.Tooltip) return;
  var Tooltip = window.bootstrap.Tooltip;
  var scope = root || document;
  var nodes = scope.querySelectorAll('[data-bs-toggle="tooltip"]');
  nodes.forEach(function (el) {
    if (Tooltip.getInstance(el)) return;
    // Skip elements that also carry a popover trigger — those manage their
    // own tooltip lifecycle (see ai_score_tooltip.js).
    if (el.hasAttribute('data-score-url')) return;
    new Tooltip(el);
  });
}

$(document).ready(function () { initTooltips(); });
// Re-scan after Rails-UJS ajax responses inject new markup.
$(document).on('ajax:complete', function (e) { initTooltips(e.target); });

export { initTooltips };
